import {Controller, Get, Post, Body} from '@nestjs/common';
import {McpService} from './mcp.service';

/**
 * MCP（模型上下文协议）控制器
 * 负责向三端暴露文件工具列表与远程文件操作接口
 */
@Controller('api/mcp')
export class McpController {
  constructor(private readonly mcpService: McpService) {}

  /**
   * 获取服务器支持的所有 MCP 工具元数据定义
   */
  @Get('tools')
  getTools() {
    try {
      const tools = this.mcpService.getToolDefinitions();
      return {
        success: true,
        data: tools,
      };
    } catch (err: any) {
      return {
        success: false,
        error: err.message,
      };
    }
  }

  /**
   * 直接远程执行指定的文件 MCP 工具
   * @param body 包含工具名称与参数
   */
  @Post('execute')
  async executeTool(@Body() body: {name: string; args: any}) {
    const {name, args} = body;

    if (!name) {
      return {
        success: false,
        error: '缺少必要的 tool name 参数',
      };
    }

    try {
      const result = await this.mcpService.executeTool(name, args);
      return {
        success: true,
        data: result,
      };
    } catch (err: any) {
      return {
        success: false,
        error: err.message,
      };
    }
  }
}
